/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const discountItemSchema = z
	.object({
		name: z.string(),
		discount: z.string(),
	})
	.describe("Сериализатор детализации скидки - для документации.");
